<template>
  <div v-click-outside="CLICK_OUTSIDE" class="u-position-relative">
    <BaseInput
      :label="label"
      :placeholder="placeholder"
      @focus="toggleSuggestions(true)"
      :block="block"
      :value="search"
      @input="input"
    />
    <div class="c-form-control__suggestion" v-if="isOpened && isRequested">
      <Loading v-if="isLoading" />
      <div v-else-if="suggestions.length === 0 && isRequested">
        <small
          ><strong>
            {{ $t("common.noSuggestions", { search: search }) }}
            {{ $t("common.continueForNewSuggestion") }}
          </strong></small
        >
      </div>
      <div v-else>
        <h6 class="u-color-muted u-margin-bottom-small">
          {{ $t("common.suggestions") }}
        </h6>
        <span
          v-for="(suggestion, i) in suggestions"
          :key="i"
          class="u-cursor-pointer u-margin-bottom-xsmall u-display-inline-block"
          @click="selectSuggestion(suggestion)"
        >
          <slot name="suggestion" :index="i" :suggestion="suggestion"></slot>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import BaseInput from "./BaseInput.vue";

export default {
  components: {
    BaseInput,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
    request: {
      type: Function,
      required: true,
    },
    block: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: "",
      lazyTimeout: -1,
      suggestions: [],
      isRequested: false,
      isLoading: false,
      isOpened: false,
      selectedSuggestions: [],
    };
  },
  methods: {
    selectSuggestion(suggestion) {
      this.input(suggestion.title, true);
      this.isOpened = false;
    },
    input(value, preventRequest = false) {
      this.search = value;
      const validSuggestion = this.suggestions.find(
        (suggestion) => suggestion.title.toLowerCase() === value.toLowerCase()
      );
      if (validSuggestion) {
        this.$emit("input", [
          ...this.selectedSuggestions,
          { id: validSuggestion.id, title: value },
        ]);
      } else
        this.$emit("input", [
          ...this.selectedSuggestions,
          { id: null, title: value },
        ]);
      if (!preventRequest) this.getSuggestions();
    },
    getSuggestions() {
      if (this.lazyTimeout !== -1) {
        clearTimeout(this.lazyTimeout);
      }
      this.lazyTimeout = setTimeout(() => {
        this.isRequested = true;
        this.isLoading = true;
        this.isOpened = true;
        this.request(this.search).then((res) => {
          if (res.message === "OK") {
            this.suggestions = res.data.items;
            this.input(this.search, true);
          }
          this.isLoading = false;
        });
      }, 1000);
    },
    CLICK_OUTSIDE() {
      this.isOpened = false;
    },
    toggleSuggestions(value) {
      this.isOpened = value;
    },
  },
};
</script>

<style></style>
